import React, { useState,useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const faqData = [
  {
    question: "What technologies do you leverage for web and software development?",
    answer:
      "We employ the latest technologies and frameworks to build robust, scalable, and efficient systems. Our stack includes HTML5, CSS3, JavaScript frameworks like React, Angular, and Vue, backend technologies such as Laravel, Node.js, and Django, along with databases like MySQL, PostgreSQL, and MongoDB. For eCommerce solutions, we work with industry-leading platforms such as Shopify, WooCommerce, and Magento, as well as custom-built solutions to suit your specific needs.",
  },
  {
    question: "Do you offer ongoing support and maintenance post-launch?",
    answer:
      "Absolutely. We understand that your digital products require continuous support and optimization. Our post-launch services include bug fixes, security patches, performance optimizations, and adding new features as your business evolves.",
  },
  {
    question: "How do you determine the cost of a custom software or web solution?",
    answer:
      "The cost of a custom solution is influenced by several factors, including the project’s complexity, feature requirements, design specifications, and technology choices.",
  },
  {
    question: "Can you integrate third-party services into my existing application?",
    answer:
      "Yes, we specialize in integrating third-party services and APIs into your applications. Whether it’s integrating payment gateways, CRM tools, or external data sources, we ensure seamless integration for a smooth user experience.",
  },
  {
    question: "How do you approach developing an eCommerce website or platform?",
    answer:
      "We design intuitive, mobile-friendly stores that provide seamless shopping experiences. Our team also integrates secure payment solutions, inventory management, and marketing tools to ensure your platform’s success.",
  },
  {
    question: "What is your process for ensuring website and application security?",
    answer:
      "Security is a priority in all our projects. We follow industry best practices, such as SSL encryption, secure authentication methods, regular vulnerability assessments, and proactive threat detection.",
  },
  {
    question: "Do you offer Digital Marketing services to help grow my business?",
    answer:
      "Yes, our team specializes in Digital Marketing services, including SEO, PPC campaigns, social media marketing, and content marketing.",
  },
  {
    question: "Can you help with the migration of my existing website or software to a new platform?",
    answer:
      "Yes, we assist with smooth migrations from one platform to another, ensuring data integrity, minimal downtime, and system compatibility.",
  },
  {
    question: "What sets your IT services apart from others?",
    answer:
      "Our services stand out due to our commitment to excellence, tailored solutions, and a customer-centric approach.",
  },
];

const Question = () => {
     useEffect(() => {
        AOS.init({ duration: 1000 }); // ✅ Initialize AOS
      }, []);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq-2" className="faq-2 section light-background">
      <div className="container section-title">
        <h2>Frequently Asked Questions</h2>
        <p>
          Our team is committed to delivering innovative IT solutions tailored to your needs.
          Below are some frequently asked questions about our services.
        </p>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="faq-container">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${activeIndex === index ? "faq-active" : ""}`}
                  onClick={() => toggleFaq(index)}
                >
                  <i className="faq-icon bi bi-question-circle"></i>
                  <h3>{item.question}</h3>
                  <div className="faq-content" style={{ display: activeIndex === index ? "block" : "none" }}>
                    <p>{item.answer}</p>
                  </div>
                  <i className={`faq-toggle bi ${activeIndex === index ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Question;
